export function hideDefaultLayout(pathname: string) {
  return (
    pathname.includes("/teaser") ||
    pathname.includes("/launch") ||
    pathname.includes("/logistics-centres") ||
    pathname.includes("/tasareeh") ||
    pathname.includes("/mandarinoriental") ||
    pathname.includes("/gardeniabay") ||
    pathname.includes("/lsq-wandsworth") ||
    pathname.includes("/wilds") ||
    pathname.includes("/nps") ||
    pathname.includes('/samayas-penthouse') ||
    pathname.includes('/detailsthatmatter') ||
    pathname.includes('/Fahid-Island')
  );
}
